import { render, staticRenderFns } from "./PositionsTemplateList.vue?vue&type=template&id=f378e19c&"
import script from "./PositionsTemplateList.vue?vue&type=script&lang=js&"
export * from "./PositionsTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports